module.exports = __webpack_public_path__ + "static/media/3.83e314d7.png";